<template>
  <div class="entering-exiting-warehouse-list">
    <div class="enter-warehouse-project">
      <div class="screen">
        <el-input class="white w240" v-model="screen.name" placeholder="请输入项目名称"></el-input>
        <el-input class="white w240" v-model="screen.wmsCode" placeholder="请输入WMS编码"></el-input>
        <el-button class="btn-blue" @click="onScreen">搜索</el-button>
      </div>
      <div class="operation-btn">
        <el-button class="btn-blue" @click="toEnteringExitIngWarehouseDetails('add')">+新增</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        ref="table"
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
      >
        <el-table-column label="序号" min-width="120">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="140"></el-table-column>
        <el-table-column prop="wmsCode" label="WMS编码" min-width="140"></el-table-column>
        <el-table-column label="操作" min-width="138">
          <template slot-scope="scope">
            <el-button
              class="btn-text"
              :disabled="!scope.row.status"
              type="text"
              @click="toEnteringExitIngWarehouseDetails('mod', scope.row.id)"
            >编辑</el-button>
            <el-button
              class="btn-text"
              :disabled="!scope.row.status"
              type="text"
              @click="toEnteringExitIngWarehouseDetails('details', scope.row.id)"
            >详情</el-button>
            <el-button
              class="btn-text"
              type="text"
              v-if="scope.row.status"
              @click="closeProject(scope.row.id)"
            >关闭</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import EnteringExitingWarehouse from "models/entering-exiting-warehouse";
import { modifyNetTitle } from "common/js/util";
export default {
  data() {
    return {
      screen: {
        name: '',
        wmsCode: ''
      },
      tableData: [], //项目列表
    };
  },
  created() {
    modifyNetTitle('进出仓项目列表')
    this.getTableData();
  },
  methods: {
    tableRowClassName({ row }) {
      if (!row.status) {
        return "close-row";
      }
    },
    onScreen() {
      this.currentPage = 1;
      this.getTableData();
    },
    //获取进出仓项目
    getTableData() {
      let code = this.screen.wmsCode;
      let name = this.screen.name;
      let data = {
        code,
        name
      }
      EnteringExitingWarehouse.getEnteringExitingWarehouseList(data).then(res => {
        if (res.success) {
          let tableData = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.status = value.status;
            obj.projectName = value.name;
            obj.wmsCode = value.wmsCode;
            tableData.push(obj);
          });
          this.tableData = tableData;
        }
      });
    },

    /** 
     * @desc 前往详情
     * @param type {string} add新增 mod编辑 details详情
     * @param id 进出仓id
    */
    toEnteringExitIngWarehouseDetails(type, id) {
      if (type === 'details') {
        let routeData = this.$router.resolve({
          path: '/base-info/project-manage/entering-exiting-warehouse/entering-exiting-warehouse-details',
          query: {
            type: type,
            projectId: id,
          }
        });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push({
          path: '/base-info/project-manage/entering-exiting-warehouse/entering-exiting-warehouse-details',
          query: {
            type: type,
            projectId: id,
          }
        })
      }
    },

    //关闭项目
    closeProject(id) {
      this.$confirm("是否确定永久关闭该项目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        EnteringExitingWarehouse.postOpenOrColseEnteringExitingWarehouse(id).then(res => {
          if (res.success) {
            this.getTableData();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.entering-exiting-warehouse-list {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .enter-warehouse-project {
    display: flex;
    justify-content: space-between;
    .screen {
      display: flex;
      .w240 {
        width: 240px;
        margin-right: 16px;
      }
    }
    .operation-btn {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 16px;
    }
  }
}
</style>
<style lang="scss">
.entering-exiting-warehouse-list {
  .table .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
    color: #b7b7b7;
    .el-button.btn-text {
      color: #b7b7b7;
      font-size: 14px;
    }
  }
}
</style>
